// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rlcs-yara-matched-rules-table tr:not(.state-expanded):not(.expanded-row) td:first-child .icon-chevron-down {
  transform: rotate(-90deg);
}

.AcHzTKzs3SrxZFDiMRMD {
  padding-left: 5%;
}

.s_6xTzhAq5PhIds5VQO3 {
  width: 52.5%;
}`, "",{"version":3,"sources":["webpack://./tcbase/static/js2/modules/samples/components/rlcloudsandbox/yara/rlcloudsandboxyara.module.scss"],"names":[],"mappings":"AAGM;EACA,yBAAA;AAFN;;AAOA;EACE,gBAAA;AAJF;;AAOA;EACE,YAAA;AAJF","sourcesContent":["@import \"/tcbase/static/style/settings/settings.rl.variables.scss\"; @import \"/tcbase/static/style/settings/settings.bs.variables.scss\";\n:global {\n    .rlcs-yara-matched-rules-table {\n      tr:not(.state-expanded):not(.expanded-row) td:first-child .icon-chevron-down {\n      transform: rotate(-90deg);\n    }\n  }\n}\n\n.rlcs_yara_pad_left {\n  padding-left: 5%;\n}\n\n.rlcs_matched_strings_width {\n  width: 52.5%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rlcs_yara_pad_left": `AcHzTKzs3SrxZFDiMRMD`,
	"rlcs_matched_strings_width": `s_6xTzhAq5PhIds5VQO3`
};
export default ___CSS_LOADER_EXPORT___;
